export default (context, inject) => {
  class MercureListener {
    constructor (subscribeTo, onReceiveMessage) {
      this.eventSource = null;
      this.onReceiveMessage = null;

      this.onReceiveMessage = onReceiveMessage;
      this.setData(subscribeTo);
    }

    disconnect () {
      if (this.eventSource !== null) {
        this.eventSource.disconnect();
      }
    }

    setData (subscribeTo) {
      const data = [];

      const objectPath = require('object-path');

      if (objectPath.has(subscribeTo, 'items')) {
        subscribeTo.items.forEach((item) => {
          data.push({
            '@id': context.$getEnv('API_URL') + item['@id'].replace('/api/v1', ''),
          });
        });
      } else if (objectPath.get(subscribeTo, 'config.url')) {
        data.push({
          '@id': subscribeTo.config.url,
        });
      } else if (typeof subscribeTo === 'string') {
        data.push({
          '@id': subscribeTo,
        });
      } else {
        console.error(new Error('Can not subscribe to mercure'), new Error(subscribeTo));
        // data = subscribeTo['hydra:member']
      }

      if (data.length > 0) {
        return this.setupEventSource(data);
      }

      return null;
    }

    setupEventSource (data) {
      if (!context.$getEnv('API_URL') || !context.$getEnv('MERCURE_HUB_URL')) {
        throw new Error('Failed te setup `mercure` listener');
      }

      this.disconnect();

      const MERCURE_HUB_URL = context.$getEnv('MERCURE_HUB_URL');
      const MERCURE_SUBSCRIBE_JWT = context.$getEnv('MERCURE_SUBSCRIBE_JWT');
      const API_URL = context.$getEnv('API_URL');
      const url = new URL(MERCURE_HUB_URL);
      const onReceiveMessage = this.onReceiveMessage;

      if (MERCURE_HUB_URL !== null && API_URL !== null) {
        data.forEach((item) => {
          url.searchParams.append('topic', `${item['@id']}`);
        });
      }

      this.eventSource = context.$sse.create({
        url: url.toString(),
        polyfillOptions: {
          headers: {
            Authorization: `Bearer ${MERCURE_SUBSCRIBE_JWT}`,
          },
        },
      });

      this.eventSource.on('message', onReceiveMessage).on('error', (err) => {
        console.error('Failed to parse or lost connection:', err);
      }).connect().catch((err) => {
        console.error('Failed make initial connection:', err);
      });

      return this.eventSource;
    }
  }

  const createMercureListener = (subscribeTo, onReceiveMessage) => (
    new MercureListener(subscribeTo, onReceiveMessage)
  );

  inject('createMercureListener', createMercureListener);
};
